import { motion } from "motion/react";

export default function ClientsWeServeSection() {
  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-14"
        >
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3">
            Our Trusted Clients
          </h2>
          <p className="text-sm md:text-base text-gray-500 mt-4 max-w-2xl mx-auto leading-relaxed">
            Trusted partner to government agencies and statutory boards across Singapore, delivering mission-critical solutions.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="w-full"
        >
          <img
            src="https://storage.readdy-site.link/project_files/27e103a4-3ee3-4a3b-ab0d-61671b061f0e/54bd4a7b-345a-459d-be0e-74568b25dae3_compressed_Screenshot-2026-07-12-151456.webp"
            alt="Our Trusted Clients Government agencies and statutory boards across Singapore"
            className="w-full h-auto object-contain"
            loading="lazy"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="w-full mt-10 md:mt-14"
        >
          <img
            src="https://storage.readdy-site.link/project_files/27e103a4-3ee3-4a3b-ab0d-61671b061f0e/466c7dee-14e8-4160-b31c-890f868fdd25_compressed_Clients---Fiberone.webp"
            alt="Trusted by Fortune 500 companies to deliver high-performance, enterprise-grade AV and AI solutions"
            className="w-full h-auto object-contain"
            loading="lazy"
          />
        </motion.div>
      </div>
    </section>
  );
}